<template>
    <div class="slat m-t-2 m-b-1 slat-draggable">
        <div class="br p-t-3 p-b-3">
            <div v-bind:class="{'br-bottom': expanded, 'p-b-3': expanded}" class="slat-group-header row row-middle">
                <div class="slat-controls slat-controls--mini m-vertical-none m-l-2">
                    <span class="i-container i-filled-dark">
                        <span class="handle">
                            <!-- /icons/drag.svg -->
                            <svg class="icon i-size-small inline icon-drag" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g transform="translate(8 3)" fill-rule="evenodd" class="icon"><rect width="3" height="3" rx="1.5"/><rect x="5" width="3" height="3" rx="1.5"/><rect y="5" width="3" height="3" rx="1.5"/><rect x="5" y="5" width="3" height="3" rx="1.5"/><rect y="10" width="3" height="3" rx="1.5"/><rect x="5" y="10" width="3" height="3" rx="1.5"/><rect y="15" width="3" height="3" rx="1.5"/><rect x="5" y="15" width="3" height="3" rx="1.5"/></g></svg>
                        </span>
                    </span>
                </div>
                <div class="slat-content p-l-2 cu-p" v-on:click="$emit('toggle-expand')">
                    <span class="f-s-2 c-muted m-r-2">{{ trans('Q:number', {number: index + 1}) }}</span>
                    <span class="badge c-bright m-r-2" v-bind:class="{'c-theme-bg': question.type === 'single', 'c-accent-bg' : question.type === 'multiple', 'c-medium-bg': question.type === 'yes_no'}">{{ typeLabel(question.type) }}</span>
                </div>
                <div class="slat-content column p-l-2 cu-p" v-on:click="$emit('toggle-expand')">
                    <span v-if=" ! expanded" class="f-s-3">{{ truncatedQuestion }}</span>
                </div>
                <div class="slat-aside text-right m-r-4">
                    <a v-if="question.id" href="#duplicate" class="i-container i-stroke-dark m-r-2" v-on:click.prevent="duplicate">
                        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" width="16" height="16" class="icon i-size-tiny"><path d="M9 9V6.2c0-1.12 0-1.68.218-2.108.192-.377.497-.682.874-.874C10.52 3 11.08 3 12.2 3h5.6c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C21 4.52 21 5.08 21 6.2v5.6c0 1.12 0 1.68-.218 2.108a2.002 2.002 0 0 1-.874.874C19.48 15 18.92 15 17.803 15H15M9 9H6.2c-1.12 0-1.68 0-2.108.218a1.999 1.999 0 0 0-.874.874C3 10.52 3 11.08 3 12.2v5.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874c.427.218.987.218 2.105.218h5.607c1.117 0 1.676 0 2.104-.218.376-.192.683-.498.874-.874.218-.428.218-.987.218-2.105V15M9 9h2.8c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874c.218.427.218.987.218 2.105V15" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
                    </a>
                    <a v-if="question.id" href="#delete" class="i-container i-filled-dark m-r-2" v-on:click.prevent="destroy">
                        <!-- /icons/s-trash.svg -->
                        <svg class="icon i-size-tiny inline" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><g fill="#6F6FFF" class="icon"><path d="M14.5 3.38h-3.512C10.923 1.782 9.613.5 8 .5S5.077 1.782 5.012 3.38H1.5a1 1 0 1 0 0 2h13a1 1 0 1 0 0-2zM8 2.5a.99.99 0 0 1 .976.88H7.024A.99.99 0 0 1 8 2.5zm5.499 3.507a1.01 1.01 0 0 0-1.104.884L11.604 14H4.396l-.79-7.109a1 1 0 0 0-1.989.22l.889 7.999A1 1 0 0 0 3.5 16h9a1 1 0 0 0 .994-.89l.889-7.999a1 1 0 0 0-.884-1.104z"/><path d="M7.5 11.5v-4a1 1 0 1 0-2 0v4a1 1 0 1 0 2 0zm3 0v-4a1 1 0 1 0-2 0v4a1 1 0 1 0 2 0z"/></g></svg>
                    </a>
                    <button type="button" class="cu-p" v-on:click="$emit('toggle-expand')">
                        <span class="i-container i-filled-dark">
                            <!-- /icons/open-alt.svg -->
                            <svg class="icon icon-expand i-size-small m-l-1" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M3.664 7.253L2.336 8.747 12 17.338l9.664-8.59-1.328-1.495L12 14.662z" class="icon"/></svg>
                        </span>
                    </button>
                </div>
            </div>

            <div v-show="expanded" class="slat-group-content p-l-4 p-r-4 p-t-4 m-t-1">
                <div class="form-group">
                    <label>
                        <span>{{ trans('Question Type') }}</span>
                        <select class="input__field" v-model="form.type">
                            <option value="single">{{ trans('Single choice') }}</option>
                            <option value="multiple">{{ trans('Multiple choice') }}</option>
                            <option value="yes_no">{{ trans('Yes / No') }}</option>
                        </select>
                    </label>
                </div>

                <div class="form-group" v-bind:class="{'has-error': errors.has('question')}">
                    <label>
                        <span>{{ trans('Question') }}</span>
                        <textarea class="input__field" rows="3" maxlength="240" v-model="form.question" style="border: 0"></textarea>
                    </label>
                    <span class="f-s-1 fr c-medium-tint">{{ form.question.length }}/240</span>
                </div>
                <div v-if="errors.has('question')" class="form-help">{{ errors.get('question') }}</div>

                <div v-if="form.type === 'single'" class="form-group">
                    <label class="m-b-2">{{ trans('Question Image (optional)') }}</label>
                    <image-upload
                        field-name="quiz_question_image"
                        v-bind:show-form-fields="false"
                        v-bind:existing-file-path="form.image || ''"
                        v-bind:existing-file-url="question.image_url ? question.image_url.full : ''"
                        v-on:image-selected="onImageUploaded"
                        v-on:image-removed="form.image = null"
                    ></image-upload>
                </div>

                <div class="form-group m-b-4 p-b-4">
                    <label class="m-b-2">{{ trans('Answer Options') }}</label>
                    <div v-for="(option, optionIndex) in form.options" v-bind:key="optionIndex" class="row row-collapse row-middle m-b-2">
                        <div>
                            <label class="control control-radio p-r-6 m-b-0" v-if="form.type !== 'multiple'">
                                <input type="radio" v-bind:name="'correct-' + question.key" v-bind:checked="option.is_correct" v-on:change="setCorrect(optionIndex)">
                                <div class="control-indicator control-radio-indicator"></div>
                            </label>
                            <label class="control control-checkbox p-r-0 m-b-0" v-else>
                                <input type="checkbox" v-model="option.is_correct">
                                <div class="control-indicator control-checkbox-indicator"></div>
                            </label>
                        </div>
                        <div class="column">
                            <div class="form-group m-b-0" v-bind:class="{'has-error': errors.has('options.' + optionIndex + '.text')}">
                                <input
                                    class="input__field"
                                    type="text"
                                    maxlength="500"
                                    v-bind:readonly="form.type === 'yes_no'"
                                    v-bind:value="form.type === 'yes_no' ? yesNoLabel(option.text) : option.text"
                                    v-on:input="form.type !== 'yes_no' && (option.text = $event.target.value)"
                                >
                            </div>
                            <div v-if="errors.has('options.' + optionIndex + '.text')" class="form-help m-t-5">{{ errors.get('options.' + optionIndex + '.text') }}</div>
                        </div>
                        <div class="m-l-4">
                            <span v-if="option.is_correct" class="f-s-1 c-success f-w-bold">{{ trans('CORRECT') }}</span>
                        </div>
                        <div class="m-l-2" v-if="form.type !== 'yes_no' && form.options.length > 2">
                            <span class="tooltip animate">
                                <button v-on:click.prevent="removeOption(optionIndex)" type="button" class="cu-p i-container i-filled-dark">
                                    <!-- /icons/s-trash.svg -->
                                    <svg class="icon i-size-tiny inline" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><g fill="#6F6FFF" class="icon"><path d="M14.5 3.38h-3.512C10.923 1.782 9.613.5 8 .5S5.077 1.782 5.012 3.38H1.5a1 1 0 1 0 0 2h13a1 1 0 1 0 0-2zM8 2.5a.99.99 0 0 1 .976.88H7.024A.99.99 0 0 1 8 2.5zm5.499 3.507a1.01 1.01 0 0 0-1.104.884L11.604 14H4.396l-.79-7.109a1 1 0 0 0-1.989.22l.889 7.999A1 1 0 0 0 3.5 16h9a1 1 0 0 0 .994-.89l.889-7.999a1 1 0 0 0-.884-1.104z"/><path d="M7.5 11.5v-4a1 1 0 1 0-2 0v4a1 1 0 1 0 2 0zm3 0v-4a1 1 0 1 0-2 0v4a1 1 0 1 0 2 0z"/></g></svg>
                                </button>
                                <span class="tooltip-content tooltip-item tooltip--top">{{ trans('Remove') }}</span>
                            </span>
                        </div>
                    </div>
                    <div v-if="form.type !== 'yes_no' && form.options.length < 6" class="text-center">
                        <button v-on:click="addOption" type="button" class="btn btn-text btn-text--accent btn-icon">
                            <span class="icon i-container i-filled-accent">
                                <!-- /icons/add.svg -->
                                <svg class="icon i-size-small inline" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g class="icon"><path d="M11 5v14h2V5z"/><path d="M19 11H5v2h14z"/></g></svg>
                            </span>
                            {{ trans('Add Option') }}
                        </button>
                    </div>
                </div>
                <div v-if="errors.has('options')" class="form-help p-t-2">{{ errors.get('options') }}</div>

                <div class="text-right">
                    <button type="button" class="btn btn-text btn-text--muted-simple m-r-2" v-on:click="cancel">{{ trans('Cancel') }}</button>
                    <button type="button" class="btn btn-primary" v-bind:class="{'btn-loading': saving}" v-on:click="save">{{ trans('Save question') }}</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { quizQuestionStoreLink, quizQuestionUpdateLink, quizQuestionDuplicateLink } from '../../routes';
import Errors from '../../errors.js';

export default {
    props: {
        question: {
            type: Object,
            required: true
        },
        index: {
            type: Number,
            required: true
        },
        quiz: {
            type: Object,
            required: true
        },
        expanded: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            form: this.cloneForm(this.question),
            saving: false,
            errors: new Errors()
        }
    },
    watch: {
        expanded(value) {
            if (value) {
                this.form = this.cloneForm(this.question);
                this.errors.clear();
            }
        },
        'form.type'(newType, oldType) {
            if ( ! oldType || newType === oldType) {
                return;
            }

            if (newType === 'yes_no') {
                this.form.options = [
                    {id: null, text: 'yes', is_correct: false},
                    {id: null, text: 'no', is_correct: false},
                ];

                return;
            }

            if (oldType === 'yes_no') {
                this.form.options = [
                    {id: null, text: '', is_correct: false},
                    {id: null, text: '', is_correct: false},
                ];

                return;
            }

            if (oldType === 'multiple' && newType === 'single') {
                let keptFirst = false;

                this.form.options = this.form.options.map((option) => {
                    if (option.is_correct && ! keptFirst) {
                        keptFirst = true;

                        return option;
                    }

                    return Object.assign({}, option, {is_correct: false});
                });
            }
        }
    },
    computed: {
        truncatedQuestion() {
            if ( ! this.question.question) {
                return '';
            }

            return this.question.question.length > 100
                ? this.question.question.substring(0, 100) + '…'
                : this.question.question;
        }
    },
    methods: {
        cloneForm(question) {
            return {
                type: question.type || 'single',
                question: question.question || '',
                image: question.image || null,
                options: (question.options && question.options.length > 0)
                    ? question.options.map((option) => ({id: option.encoded_id || null, text: option.text, is_correct: !! option.is_correct}))
                    : [
                        {id: null, text: '', is_correct: false},
                        {id: null, text: '', is_correct: false},
                    ],
            };
        },
        typeLabel(type) {
            return {
                single: this.trans('Single choice'),
                multiple: this.trans('Multiple choice'),
                yes_no: this.trans('Yes / No'),
            }[type] || type;
        },
        yesNoLabel(text) {
            return text === 'no' ? this.trans('No') : this.trans('Yes');
        },
        setCorrect(optionIndex) {
            this.form.options = this.form.options.map((option, index) => Object.assign({}, option, {is_correct: index === optionIndex}));
        },
        addOption() {
            this.form.options.push({id: null, text: '', is_correct: false});
        },
        removeOption(optionIndex) {
            this.form.options.splice(optionIndex, 1);
        },
        onImageUploaded(response) {
            this.form.image = response.path;
        },
        cancel() {
            if ( ! this.question.id) {
                this.$emit('discard-new');

                return;
            }

            this.form = this.cloneForm(this.question);
            this.errors.clear();
            this.$emit('toggle-expand');
        },
        save() {
            this.saving = true;
            this.errors.clear();

            const payload = {
                type: this.form.type,
                question: this.form.question,
                image: this.form.type === 'single' ? this.form.image : null,
                options: this.form.options.map((option) => ({
                    id: option.id,
                    text: option.text,
                    is_correct: !! option.is_correct,
                })),
            };

            const request = this.question.id
                ? window.axios.put(quizQuestionUpdateLink(this.quiz, this.question), payload)
                : window.axios.post(quizQuestionStoreLink(this.quiz), payload);

            request
                .then((response) => {
                    this.saving = false;
                    this.$emit('saved', response.data);
                })
                .catch((error) => {
                    this.saving = false;

                    if (error.response && error.response.status === 422) {
                        this.errors.record(error.response.data);

                        return;
                    }

                    this.$toast.danger(this.trans('Something went wrong. Please try again.'));
                });
        },
        duplicate() {
            window.axios
                .post(quizQuestionDuplicateLink(this.quiz, this.question))
                .then((response) => {
                    this.$emit('duplicated', response.data);
                });
        },
        destroy() {
            this.$dialog.confirm(this.trans('Are you sure you want to delete this question?'), {loader: true})
                .then((dialog) => {
                    window.axios
                        .delete(quizQuestionUpdateLink(this.quiz, this.question))
                        .then((response) => {
                            dialog.close();
                            this.$emit('deleted', response.data);
                        });
                });
        }
    }
}
</script>
